import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { listFlowsSelect } from '../../api/flow'
import { listScreensSelect } from '../../api/screen'
import { tv_url } from '../../config/config'
import { routes } from '../../config/routes'
import { checkAccess } from '../../utils/accesses'
import { trans } from '../../utils/utilsTrans'
import Badge from '../UI/Badges/Badge'
import {
  ErrorButton,
  PrimaryButton,
  SecondaryButton,
} from '../UI/Buttons/Button'
import { SecondaryIconButton } from '../UI/Buttons/IconButton'
import Input from '../UI/Inputs/Input'
import Modal from '../UI/Modal'
import Tooltip from '../UI/Utils/Tooltip'
import TooltipBubble from '../UI/Utils/TootltipBubble'

const ModalAssociateScreen = ({
  onConfirm,
  onRemove,
  closeModal,
  currentFlow,
  rootFlow,
  loadingAssociate,
  companyId,
  screen_count
}) => {
  // TODO GET ORIENTATION SCREEN IN LISTING
  const orientation = 'horizontal'
  const [data, setData] = useState([])
  const [isLoading, setLoading] = useState(true)
  const [search, setSearch] = useState(null)
  const [filteredData, setFilteredData] = useState([])
  const [copiedElementId, setCopiedElementId] = useState(null)

  const isEmpty = screen_count === 0
  const type = 'screen'

  const types = {
    flow: listFlowsSelect,
    screen: listScreensSelect,
  }

  useEffect(() => {
    setLoading(loadingAssociate || true)

    types[type]({companyId})
      .then((data) => {
        const newData = [...data]
        newData.sort((a, b) => {
          return a.flow ? -1 : b.flow ? 1 : 0
        })
        setData([...newData])
        setFilteredData([...newData])
        setLoading(false)
      })
      .catch()
      .finally(() => setLoading(false))
  }, [rootFlow?.screens?.length])

  useEffect(() => {
    setFilteredData(
      data.filter((v) => v.name.toLowerCase().includes(search.toLowerCase()))
    )
  }, [search])

  useEffect(() => {
    if (copiedElementId) {
      const timer = setTimeout(() => {
        setCopiedElementId(null)
      }, 1000)

      return () => clearTimeout(timer)
    }

    return null
  }, [copiedElementId])

  const noScreenContent = () => {
    return (
      <div className='flex flex-col text-center justify-center items-center relative'>
        <button
          type='button'
          onClick={closeModal}
          className='rounded-full absolute top-16 right-16 text-xl z-50 bg-backgroundPrimary text-greyLight2 min-w-[36px] h-[36px] flex items-center justify-center transition-colors duration-200 hover:bg-primaryLight3 hover:text-primary'
        >
          <i className='icon-close' />
        </button>
        <div className='pt-[56%] relative w-full overflow-hidden'>
          <img
            src='/public/images/no_screen.jpg'
            className='bg-greyLight7 rounded-8 text-center absolute top-0 left-0 w-full'
            alt=''
          />
        </div>
        <div className='pt-24 pb-40 px-32 flex flex-col text-center justify-center'>
          <h3 className='mb-8 text-lg font-bold'>
            {trans('screen.get_screen_title')}
          </h3>
          <p className='mb-24 text-greyLight1 text-sm'>
            {trans('screen.get_screen_subtitle')}
          </p>
          {/*TODO Changer traduction*/}
          <TooltipBubble
            disabled={checkAccess('subscription.modify')}
            text={trans('subscription.contact_administrator')}
            fullWidth={false}
            position={'top center'}
          >
            <PrimaryButton
              disabled={!checkAccess('subscription.modify')}
              link={routes.change_offer}
              text={trans('screen.add')}
              extraClass='w-full'
            />
          </TooltipBubble>
        </div>
      </div>
    )
  }

  const noScreenFound = () => {
    return (
      <div className='flex flex-col text-center justify-center items-center p-32'>
        <h3 className='mb-8 font-semibold'>{trans('no_result')}</h3>
        <p className='text-sm text-greyLight3'>
          {trans('screen.no_result_with')} ”{search}”
        </p>
      </div>
    )
  }

  const selectScreenContent = () => {
    return (
      <div className={'flex flex-col flex-grow min-h-[0] '}>
        <div className={'flex-grow min-h-[0] overflow-auto p-24 pb-48 '}>
          {filteredData?.map((element) => (
            <div
              key={element.id}
              className={
                'w-full border border-greyLight7 rounded-8 flex items-center p-16 mb-8 ' +
                (loadingAssociate || isLoading
                  ? ' opacity-50 bg-greyLight8'
                  : ' ')
              }
            >
              <div
                className={
                  'bg-backgroundPrimary rounded-8 border border-greyLight7 text-greyLight5 mr-16 ' +
                  (orientation === 'horizontal'
                    ? ' px-12 py-8'
                    : ' px-10 py-16')
                }
              >
                <i className='icon icon-image-indent-left' />
              </div>
              <div className='space-y-8'>
                <p className='font-medium text-sm'>{element.name}</p>
                {element.flow ? (
                  <Badge
                    text={element.flow?.name || currentFlow.name}
                    isPlaying={true}
                    type='success'
                    size='small'
                  />
                ) : null}
              </div>
              <div className='flex items-center justify-between gap-4 ml-auto'>
                {!element.flow ? (
                  <SecondaryButton
                    text={trans('screen.associate_screen.submit')}
                    icon='icon-link '
                    cypress={'associate-screen'}
                    loading={
                      loadingAssociate === element.id || isLoading === element.id
                    }
                    size='small'
                    onClick={() => {
                      onConfirm(element)
                    }}
                  />
                ) : (
                  <>
                    <TooltipBubble
                      text={trans('copy_action')}
                      fullWidth={false}
                      position='top center'
                    >
                      <SecondaryIconButton
                        // text={trans('copy')}
                        icon={`icon icon-${
                          copiedElementId === element.id ? 'check' : 'copy'
                        }`}
                        size='small'
                        onClick={() => {
                          navigator.clipboard
                            .writeText(
                              `${tv_url}?session_key=${element.token}&id=${element.uuid}&preinitialize=true`
                            )
                            .then(() => setCopiedElementId(element.id))
                        }}
                      />
                    </TooltipBubble>
                    <TooltipBubble
                      text={trans('launch_action')}
                      fullWidth={false}
                      position='top center'
                    >
                      <PrimaryButton
                        text={trans('launch')}
                        icon='icon-play'
                        size='small'
                        onClick={() => {
                          window.open(
                            `${tv_url}?session_key=${element.token}&id=${element.uuid}&preinitialize=true`,
                            '_blank'
                          )
                        }}
                      />
                    </TooltipBubble>
                  </>
                )}
                {element.flow?.id && element?.flow?.id === rootFlow?.id ? (
                  <div className='flex items-center'>
                    <ErrorButton
                      text={trans('flow.associate.dissociate_screen')}
                      icon='icon-link-broken'
                      loading={
                        loadingAssociate === element.id || isLoading === element.id
                      }
                      size='small'
                      onClick={() => {
                        onRemove(element)
                      }}
                    />
                    <Tooltip
                      width={300}
                      whiteSpace={false}
                      position={'bottom left'}
                      text={trans('flow.associate.dissociate_screen_tip')}
                    />
                  </div>
                ) : null}
                {element.flow?.id && element?.flow?.id !== rootFlow?.id ? (
                  <SecondaryButton
                    text={trans('screen.associate_screen.replace')}
                    icon='icon-refresh '
                    size='small'
                    loading={
                      loadingAssociate === element.id || isLoading === element.id
                    }
                    onClick={() => {
                      onConfirm(element)
                    }}
                  />
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  return (
    <Modal
      type={isEmpty ? 'small' : 'semiMedium'}
      closeModal={closeModal}
      hasCloseButton={!isEmpty}
      title={!isEmpty ? trans('flow.associate.share') : null}
      subTitle={!isEmpty ? trans('flow.associate.select_screen') : null}
    >
      {isEmpty ? (
        noScreenContent()
      ) : (
        <div className='flex-grow min-h-[0] flex flex-col'>
          <div className='px-24 mt-32 border-b border-greyLight7 pb-16'>
            <Input
              onChange={(value) => setSearch(value)}
              value={search}
              placeholder={trans('flow.associate.search_screen')}
            />
          </div>
          <div className='flex-grow min-h-[0] flex flex-col'>
            {filteredData.length === 0 &&
            data.length &&
            !isLoading &&
            !loadingAssociate
              ? noScreenFound()
              : null}
            {filteredData.length !== 0 || isLoading || loadingAssociate
              ? selectScreenContent()
              : null}
          </div>
        </div>
      )}
    </Modal>
  )
}

ModalAssociateScreen.defaultProps = {
  type: 'screen',
}

const mapStateToProps = (state) => {
  return {
    screen_count: state.auth?.currentCompany?.extra?.screenCount,
  }
}

export default connect(mapStateToProps)(ModalAssociateScreen)
